import React, { ReactNode, Fragment } from 'react';

import { nanoid } from '@reduxjs/toolkit';

import { bemCssModules, getTestId } from '@utils';

import style from './Illustration.scss';

const cn = bemCssModules(style, 'Illustration');
const ti = getTestId('Illustration');
export type TIllustration = {
  images: ReactNode[];
};

const Illustration: CustomFC<TIllustration> = React.memo(({ className, images }) => (
  <div className={cn(null, [className])} data-testid={ti('illustration')}>
    {images.map(image => {
      if (typeof image !== 'string') return <Fragment key={nanoid()}>{image}</Fragment>;
      const split = image.split('/');
      const alt = split[split.length - 1]?.split('.')?.[0];
      return <img key={nanoid()} src={image} alt={alt} />;
    })}
  </div>
));

export default Illustration;
